import Calculator from './calculator'

export default class NoDiscountCalculator implements Calculator {
  calculateDiscountPrice(_originalPrice: number): number {
    return 0
  }
}
